import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CreditStatus } from '@payments/constants/payment-dashboard';
import { DashboardSortFields } from '@payments/pages/payment-dashboard/services/payment-dashboard.service';
import { SortDirection, SortFilter } from '@usf/ngrx-payment';
import { CustomerMetrics } from '@usf/payment-types';

@Component({
  template: '',
})
export class PaymentDashboardTablesComponent {
  @Input() customersMetrics: CustomerMetrics[];
  @Input() isDesktop: boolean;
  @Input() sort: SortFilter[];
  @Output() handleSortEmitter = new EventEmitter<SortFilter>();

  readonly CreditStatus = CreditStatus;
  readonly HeaderFields = DashboardSortFields;
  readonly SortDirection = SortDirection;

  sortedDirection = SortDirection.DESC;
  sortedField = DashboardSortFields.creditStatus;

  constructor(readonly router: Router) {}

  handleSort(newSort: { sortField: string; sortDirection: SortDirection }) {
    if (newSort.sortField === this.sortedField) {
      this.sortedDirection =
        this.sortedDirection === SortDirection.ASC
          ? SortDirection.DESC
          : SortDirection.ASC;
    } else {
      this.sortedDirection = newSort.sortDirection;
    }
    this.sortedField = newSort.sortField as DashboardSortFields;
    this.handleSortEmitter.emit({
      fieldName: newSort.sortField,
      sortValue: this.sortedDirection,
    });
  }
}
